import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Dropdown, Icon } from 'semantic-ui-react';
import { ColorTheme } from '../../KbLabFront';
import './ListSortOptions.scss';
export var SortDirection;
(function (SortDirection) {
    SortDirection[SortDirection["asc"] = 0] = "asc";
    SortDirection[SortDirection["desc"] = 1] = "desc";
})(SortDirection || (SortDirection = {}));
;
export var SortCriterion;
(function (SortCriterion) {
    SortCriterion[SortCriterion["ranking"] = 0] = "ranking";
    SortCriterion[SortCriterion["weight"] = 1] = "weight";
    SortCriterion[SortCriterion["label"] = 2] = "label";
})(SortCriterion || (SortCriterion = {}));
;
export const ListSortOptions = ({ className, colorTheme = ColorTheme.white, sortCriterion, sortDirection, onSetSortCriterion, onSetSortDirection }) => {
    const initialSortDirection = {
        [SortCriterion.label]: SortDirection.asc,
        [SortCriterion.ranking]: SortDirection.asc,
        [SortCriterion.weight]: SortDirection.desc
    };
    const setSortCriterion = (_, data) => {
        const crit = data.value;
        onSetSortCriterion(crit);
        requestAnimationFrame(() => {
            onSetSortDirection(initialSortDirection[crit]);
        });
    };
    const toggleSortDirection = () => {
        onSetSortDirection(sortDirection === SortDirection.asc ? SortDirection.desc : SortDirection.asc);
    };
    const clsx = [
        'list-sort-options',
        colorTheme,
        className !== null && className !== void 0 ? className : ''
    ].join(' ');
    return (_jsxs("div", { className: clsx, children: [_jsx(Dropdown, { fluid: true, selection: true, value: sortCriterion, options: [
                    { key: "sort-by-ranking", text: "Sorter etter rangering", value: SortCriterion.ranking },
                    { key: "sort-by-weight", text: "Sorter etter vekting", value: SortCriterion.weight },
                    { key: "sort-by-label", text: "Sorter etter navn", value: SortCriterion.label }
                ], onChange: setSortCriterion }), _jsx("div", { onClick: toggleSortDirection, title: `Endre sorteringsrekkefølge`, className: "sort", children: _jsx(Icon, { name: `sort amount ${sortDirection === SortDirection.asc ? 'up' : 'down'}` }) })] }));
};
